<template>
  <div id="app">
    <div class="bg">
      <button class="download-button" @click="downloadApp">Download App</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  methods: {
    downloadApp() {
      if(this.isInWechat) {
        alert('请在浏览器中打开！');
        return;
      }
      if(this.isAndroid) {
        // window.location.href = 'http://www.example.com/android.apk'; // 替换为你的 Android APP 下载链接
      } else if(this.isiOS) {
        // window.location.href = 'itms-apps://itunes.apple.com/app/idxxxxxx'; // 替换为你的 iOS APP 在 App Store 的链接
      }
    }
  },
  computed: {
    userAgent() {
      return window.navigator.userAgent;
    },
    isInWechat() {
      return /micromessenger/.test(this.userAgent.toLowerCase());
    },
    isAndroid() {
      return /android/.test(this.userAgent.toLowerCase());
    },
    isiOS() {
      return /(iphone|ipod|ipad)/.test(this.userAgent.toLowerCase());
    }
  }
}
</script>

<style>
#app {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg {
  background: linear-gradient(to right, #1e3c72, #2a5298);
  width: 100%;
  height: 100%;
}

.download-button {
  padding: 10px 20px;
  background: white;
  border: none;
  outline: none;
  color: #2a5298;
  border-radius: 4px;
  font-size: 18px;
  cursor: pointer;
}
</style>
